class PopupMini {
	constructor(element) {
		this.wrapper = document.querySelector(`${element}`);
		this.popup = this.wrapper.querySelector('.js-popup');
		this.btnOpen = this.wrapper.querySelector('.js-popup-open');
		this.btnClose = this.wrapper.querySelector('.js-popup-close');
		this.btnOpen.addEventListener('click', this.open.bind(this));
		this.btnClose.addEventListener('click', this.close.bind(this));
		this.init();
	}

	open() {
		if (this.popup.classList.contains('is-hide')) {
			setTimeout(() => {
				this.popup.classList.remove('is-hide');
				this.popup.classList.add('is-vision');
				this.popup.style.display = 'block';
			}, 300);
		}
	}

	close() {
		if (this.popup.classList.contains('is-vision')) {
			this.popup.classList.remove('is-vision');
			this.popup.classList.add('is-hide');
			setTimeout(() => {
				this.popup.style.display = 'none';
			}, 500);
		}
	}

	init() {
		document.addEventListener('click', (e) => {
			if (!e.target.closest('.js-popup') && !this.popup.classList.contains('is-hide')) {
				this.close();
			}
		});
		document.addEventListener('keyup', (e) => {
			if (e.key === 'Escape' && this.popup.classList.contains('is-vision')) {
				this.close();
			}
		});
	}
}

export default PopupMini;
